import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useStaticQuery, graphql } from "gatsby"
import CommonSection from "../../../components/CommonSection";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from '@emotion/styled';

import { Swiper, SwiperSlide } from 'swiper/react';

import SwiperCore, { Lazy, Keyboard } from 'swiper';

import Modal from './Modal';

import * as breakpoint from '../../../styles/breakpoints.module.scss';
import Pagination from './Pagination';

import Art from './Art';

import AnimatedSection from '../../../components/AnimatedSection';

import { useLocalization } from "gatsby-theme-i18n";
import { parseHTML } from '../../../functions/common'


SwiperCore.use([Lazy, Keyboard]);


const ListingSection = ({ list, currentSection, path }) => {
  const [ modalSwiper , setModalSwiper] = useState(null);
  const [ modalDisplay , setModalDisplay ] = useState(null);
  const [ isBeginning, setIsBeginning] = useState(true);
  const [ isEnd, setIsEnd] = useState(false);
  const { t } = useLocalization();
 

  const params = {
    preloadImages: false,
    allowTouchMove:true,
    lazy : {
      checkInView: true,
      loadPrevNext:true
    },
    spaceBetween: 0,
    slidesPerView: 'auto',
    keyboard : {
      enabled : true
    }
  }

  const data = useStaticQuery(graphql`
    query List {
      btnArrow : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/btn_arrow_white.png"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      loading : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/loading_dark.gif"}) {
        publicURL 
      }
    }
  `);

  const finalList = useMemo(() => list.nodes.filter(elem => elem.deleted !== "true"),[list])

  const openPopup = useCallback((e,index) => {
    if(e)
      e.preventDefault();


    setModalDisplay(true);
    modalSwiper.slideTo(index,0);

    if(window)
    {
      if (window.history.pushState) {
          // IE10, Firefox, Chrome, etc.
          window.history.pushState(null, null, '#' + finalList[index].number);
      } else {
          // IE9, IE8, etc
          window.location.hash = '#!' + finalList[index];
      }
    }

    setTimeout(()=>{
      modalSwiper.update();
    },100);

  },[modalSwiper,setModalDisplay,list.nodes]);

  useEffect(() => {
    if(window && window.location.hash !== '' && modalSwiper)
    {
      var id = window.location.hash.replace(/^#!?/, '');
      var match = finalList.filter(elem => elem.number === id);
      if(match.length > 0)
      {
        var index = finalList.indexOf(match[0]);
        openPopup(null,index);
      }
    }
  },[list,openPopup,modalSwiper]);


  return (<>
  <AnimatedSection>
    <Pagination section={currentSection} pageInfo={list.pageInfo} path={path} />
  </AnimatedSection>
  
  <AnimatedSection>
    <ListWrapper>
      {finalList.map((item,index) => 
        <Art item={item} key={`piece_${index}`} path={path} onClick={
          (e) => {
            openPopup(e,index);
          }
        }/>
      )}
    </ListWrapper>
  </AnimatedSection>

  <AnimatedSection>
    <Pagination section={currentSection} pageInfo={list.pageInfo} path={path} />
  </AnimatedSection>



  <Modal isOpen={modalDisplay} setModal={setModalDisplay} onModalClose={(e) => {

    if(window)
    {
      if (window.history.pushState) {
          // IE10, Firefox, Chrome, etc.
          window.history.pushState('', document.title, window.location.pathname);
      } else {
          // IE9, IE8, etc
          window.location.hash = '#';
      }
    }
  }}>
    <NavButton href="#" direction={'left'} className={'button-prev'+(isBeginning ? ' hided' : '')} onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        modalSwiper.slidePrev();
      }}>
        <GatsbyImage image={getImage(data.btnArrow)} alt={'Prev'} />
    </NavButton>
    <NavButton href="#" direction={'right'} className={'button-next'+(isEnd ? ' hided' : '')} onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        modalSwiper.slideNext();
      }}>
      <GatsbyImage image={getImage(data.btnArrow)} alt={'Next'} />
    </NavButton>
    <Swiper 
      onSwiper={setModalSwiper} 
      onSlideChange={ (e) =>{
        
        if(window && typeof e.activeIndex !== "undefined")
        {          
          if (window.history.pushState) {
              // IE10, Firefox, Chrome, etc.
              window.history.pushState(null, null, '#' + finalList[e.activeIndex].number);
          } else {
              // IE9, IE8, etc
              window.location.hash = '#!' + finalList[e.activeIndex].number;
          }
        }


        if(e.isBeginning)
          setIsBeginning(true);
        else
          setIsBeginning(false);

        if(e.isEnd)
          setIsEnd(true);
        else
          setIsEnd(false);
      }}
      
      {...params}>
        {finalList.map((item,index) => 
        <SwiperSlide key={`modal_${index}`}>
          <Popup key={`piece_popup_${index}`}>
            <PopupFrame onClick={(e) => {
              e.stopPropagation();
            }} width={item.images.origin.width} height={item.images.origin.height}>
              {(item.number && path === 'fan-art-contest') && <PopupCopyLabel>{`${t('fan_art_contest.art.number.prefix')}${item.number}`}</PopupCopyLabel>}
              <img src={data.loading.publicURL} data-src={item.images.origin.url} className="swiper-lazy" alt={item.title+' '+item.nickname}/>
              <div className="swiper-lazy-preloader"></div>
            </PopupFrame>
            <PopupText  onClick={(e) => {
              e.stopPropagation();
            }}>
              <span>{parseHTML(item.title)}</span>
              <span className="nickname">{parseHTML(item.nickname)}</span>
            </PopupText>
            
          </Popup>
        </SwiperSlide>
      )}
    </Swiper>  
  </Modal>
  </>);
}
 
export default ListingSection;


const ListWrapper = styled(CommonSection)`
  
  >div{
    padding-top:48px;
    padding-bottom:0;
    display:grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 48px;
    row-gap: 48px;
    align-items: start;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    >div{
      padding-top:20px;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 32px;
      row-gap: 32px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    >div{
      padding-top:24px;
      grid-template-columns: repeat(1, 1fr);
      column-gap: 16px;
      row-gap: 16px;
    }
  }
`


const NavButton = styled.a`
  display:block;
  width:64px;
  height:64px;
  z-index:10;

  

  position:fixed;
  top:50vh;
  margin-top:-32px;

  ${props => props.direction === "left" ? `
  left:48px;
  transform:rotate(180deg);`: `right:48px;`}

  &.hided{
    opacity:.5;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    display:none;
  }

`


const Popup = styled.div`
  line-height:0;
  margin:0 auto;
  padding:62px 0 0;
`

const PopupFrame = styled.div`
  display: inline-block;
  margin:0 auto;
  position:relative;
  max-width:calc(100% - 250px);
 

  @media only screen and (max-width: ${breakpoint.smMax}){
    max-width:calc(100% - 96px);
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    max-width:calc(100% - 48px);
  }

  img {
    max-width:100%;
    max-height:calc(100vh - 62px - 150px);
    object-fit: contain;
    min-width:100px;
    min-height:100px;
  }

  
`

const PopupCopyLabel = styled.div`
  margin-bottom:20px;
  color: #CACACD;
  font-size: 20px;
  line-height: 32px;
  font-weight:bold;
  position:absolute;
  bottom:100%;
  right:0;
  left: 0;

  > svg{
    margin-right:16px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin-bottom:12px;
    font-size: 16px;
    line-height: 24px;
    > svg{
      width:16px;
      height:16px;
      margin:0px 12px 0px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-bottom:8px;
    font-size: 14px;
    line-height: 24px;
    > svg{
      width:16px;
      height:16px;
      margin:0px 8px 0px;
    }
  }
`

const PopupText = styled.div`
  padding-top: 32px;
  font-size: 20px;
  line-height: 32px;
  text-indent: 0.03em;
  letter-spacing: 0.03em;
  color: #F2F2F5;
  font-weight:bold;
  position:relative;
  width:calc(100vw - 96px);
  text-align:center;
  margin:0 auto;

  .nickname{
    display:block;
    margin-top:8px;
    font-size: 16px;
    line-height: 28px;
    font-weight:normal;
    color: #ECECEF;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding-top:32px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding-top:16px;
    font-size: 16px;
    line-height: 24px;
    width:calc(100vw - 48px);

    .nickname{
      margin-top:4px;
      font-size: 14px;
    line-height: 20px;
    }
  }
`





